import gql from 'graphql-tag';

import client from '../graphqlAPI';

const RESTORE_EMAIL_TEMPLATE_REVISION_MUTATION = gql`
  mutation restoreEmailTemplateRevision($templateId: String!, $revisionIndex: Int!) {
    restoreEmailTemplateRevision(templateId: $templateId, revisionIndex: $revisionIndex) {
      isAuth
      success
      error
      template {
        _id
        templateId
        name
        language
        scope
        subject
        preheader
        htmlContent
        textContent
        sampleData
        needsReview
        variables
        isActive
        source
        appName
        updatedAt
        revisions {
          subject
          preheader
          htmlContent
          textContent
          sampleData
          author
          savedAt
        }
      }
    }
  }
`;

const restoreEmailTemplateRevision = async ({ templateId, revisionIndex }) => {
  try {
    const result = await client
      .mutate({
        mutation: RESTORE_EMAIL_TEMPLATE_REVISION_MUTATION,
        variables: { templateId, revisionIndex },
        fetchPolicy: 'no-cache',
      })
      .then(mutationResult => mutationResult)
      .catch((mutationError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Mutation Error: ${mutationError}`);
        return null;
      });

    const { data: { restoreEmailTemplateRevision: restoreEmailTemplateRevisionData } } = result;

    if (restoreEmailTemplateRevisionData) return restoreEmailTemplateRevisionData;

    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Mutation Error: restoreEmailTemplateRevisionData = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: restoreEmailTemplateRevision Error: ${error}`);
    return null;
  }
};

export default restoreEmailTemplateRevision;
